export const apiUrl =
  process.env.REACT_APP_ENVIRONMENT === "development"
    ? "http://54.251.101.32:3002/admin" : process.env.REACT_APP_ENVIRONMENT === "production" ? `${process.env.REACT_APP_API_URL}/admin`
      : "http://localhost:3002/admin";

export const appUrl =
  process.env.REACT_APP_ENVIRONMENT === "development"
    ? "http://gig8.co" : process.env.REACT_APP_ENVIRONMENT === "production" ? process.env.REACT_APP_API_URL
      : "http://localhost:3002";
